import React from 'react';
import { Modal } from 'react-bootstrap';
import Button from 'commonComponents/Button/Button';
import PhotoAndContact from '../PhotoAndContact/PhotoAndContact';
import NameAndPosition from '../NameAndPosition/NameAndPosition';
import styles from './EmployeeModal.module.scss';

const EmployeeModal = ({ employee, contacts, button, show, handleClose }) => {
  return (
    <Modal
      show={ show }
      onHide={ handleClose }
      className={ styles.EmployeeModal }
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header className={ styles.modalHeader } closeButton />
      <Modal.Body className={ styles.modalBody }>
        <PhotoAndContact { ...{ employee, contacts } } />
        <div className={ styles.info }>
          <NameAndPosition { ...employee } />
          <p>{ employee.description }</p>
        </div>
      </Modal.Body>
      <Modal.Footer className={ styles.modalFooter }>
        <Button label={ button } onClick={ handleClose } />
      </Modal.Footer>
    </Modal>
  );
};

export default EmployeeModal;
